<template>
  <AbsPopup id="LinkPopup" title="링크 만들기" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <div>
          <span>객체에 연결할 URL을 입력해 주세요</span>
        </div>
        <ul>
          <li>
            <span><b>선택된 객체</b></span>
            <span>{{ selectMessage }}</span>
          </li>
          <UInput type="text" tag="li" placeholder="" v-model="link" align="right">
            <span><b>URL</b></span>
          </UInput>
        </ul>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  mounted () {
    this.link = this.option.param.link
    document.querySelector('.popup-body input').focus()
    this.$emit('loading', false)
  },
  data: () => {
    return {
      link: ''
    }
  },
  name: 'linkpopup',
  computed: {
    selectMessage: function () {
      return this.option.param.range.toString() === '' ? '없음' : this.cutString(this.option.param.range.toString())
    },
    message: function () {
      return (this.option) ? this.option.message : ''
    }
  },
  methods: {
    cutString (st) {
      return (st.length > 10) ? st.substring(0, 20) + '...' : st
    },
    submit () {
      this.$emit('submit', this.link)
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
.popup-body {
  margin: 10px 0px;
  width: 400px;
}
.popup-body ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  margin: 10px 20px;
}
.popup-body > div > span {
  font-size: 0.9em;
}
.popup-body ul li {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 45px;
  align-items: center;
  border-bottom: 1px solid var(--line-base);
}
.popup-body ul li span:first-child {
  margin: 0px 10px 0px 0px;
}
.popup-body ul li input {
  flex: 1;
  text-align: right;
  margin: 0px 20px 0px 0px;
}
.popup-body ul li span:last-child {
  flex: 1;
  text-align: right;
  margin: 0px 20px 0px 0px;
}
.modal-default-button {
  float: right;
}
.modal-footer {
  display: flex;
  width: 100%;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/LinkPopup.vue